<template>
    <div class="model filterContent">
        <div class="model_header filterContent">
            <div class="item " v-for="item in withDrawList" :key="item.id">
                <div class="top flex" >
                  <span class="flex1"> {{ payStatus[item.payStatus] }}</span>
                  <span class="flex1 date text-align-right">{{ dateFormat(item.createDate) }}</span>
                </div>
                <div class="bottom flex" >
                  <span class="flex1 money">￥{{ (item.money / 100).toFixed(2) }}</span>
                  <span  class="flex1 link text-align-right" @click="viewDetail(item.id)" >查看详情></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { formate } from '../../utils/utils'

export default {
  props: ['payStatus', 'withDrawList'],
  name: 'WithDrawRecord',
  created() {
      this.dateFormat = formate;
  },
  methods: {
      viewDetail: function(id) {
          this.$router.push(`/user/confirmWithDraw?withDrawId=${id}`);
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.model_header {
    height: unset;
    padding: 0;
}
.flex {
    display: flex;
}
.flex1 {
    flex: 1;
}
.item {
  height: 70px;
  padding: 0 20px;
  border-bottom: 1px solid #dfdfdf;
  .top {
    clear: both;
    height: 25px;
  }
  .bottom {
    height: 20px;
  }
  .date { color: #9c9c9c }
  .money {
    color: #3e3e3e;
  }
  .link {
    color: #67b4ab;
  }
}
  .float-right {
    float: right;
  }
  .float-left{
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/userWithDrawElement/WithDrawRecord.vue